module.exports = __webpack_public_path__ + "img/eye.766c07bd.svg";